import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { ClinicStudiesQuery, ClinicStudiesQueryVariables } from '@/shared/api';
import CLINIC_STUDIES_QUERY from '../queries/clinicStudies';

/**
 * Loads a filtered page of clinic studies for the study list. Runs CLINIC_STUDIES_QUERY with the filter and limit and throws the first GraphQL error message when clinicStudies comes back nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @returns The clinic studies page.
 */
const fetchClinicStudies = async (
  filter: ClinicStudiesQueryVariables['filter'],
  limit = 10,
): Promise<ClinicStudiesQuery['clinicStudies']> => {
  const client = createClient();
  const clinicStudiesResult = await client.query<ClinicStudiesQuery, ClinicStudiesQueryVariables>({
    query: CLINIC_STUDIES_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = clinicStudiesResult;
  const { clinicStudies } = data;
  if (_.isNil(clinicStudies) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return clinicStudies;
};

export default fetchClinicStudies;
